module.exports = __webpack_public_path__ + "img/card_math.01215fa7.png";